import { createApp } from 'vue';
import WoffToOtfConverter from '@/Components/WoffToOtfConverter.vue';
import '@styles/app.css';

createApp(WoffToOtfConverter).mount('#woff-to-otf-converter');
